/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { IPageOrderIdTranslation } from '../../../../modules/internationalization/types';
import {
    TableCellLink,
    TableCellStatusBlock,
    TableCellText,
    TableHeader,
    useTableMsisdnCell,
} from '../../../../modules/table';
import { TTableColumnCell } from '../../../../modules/table/types';
import { IOrderIdSubscriber } from '../../types';

export const OrderIdTableColumns = (
    { subscriberList }: IPageOrderIdTranslation,
    columns: {
        hasLabels: boolean;
        hasName: boolean;
    },
): Array<TTableColumnCell<IOrderIdSubscriber>> => {

    const useMsisdnCell = ({ msisdn, id }: IOrderIdSubscriber) => useTableMsisdnCell(id, msisdn);
    const { hasLabels, hasName } = columns;

    const columnsConfig: Array<TTableColumnCell<IOrderIdSubscriber>> = [
        {
            accessor: 'msisdn',
            Header: <TableHeader disableSort label={subscriberList.msisdn} name="msisdn"/>,
            disableResizing: true,
            minWidth: 200,
            ...TableCellLink<IOrderIdSubscriber>(useMsisdnCell),
        },
    ];

    if (hasName) {
        columnsConfig.push({
            accessor: 'name',
            Header: <TableHeader disableSort label={subscriberList.name} name="name"/>,
            disableResizing: true,
            minWidth: 290,
            ...TableCellText<IOrderIdSubscriber>(({ name }) => name),
        });
    }

    if (hasLabels) {
        columnsConfig.push({
            accessor: 'label',
            Header: <TableHeader disableSort label={subscriberList.label} name="label"/>,
            disableResizing: true,
            minWidth: 290,
            ...TableCellText<IOrderIdSubscriber>(({ label }) => label),
        });
    }

    columnsConfig.push({
        // @ts-ignore
        accessor: 'status',
        Header: <TableHeader disableSort label={subscriberList.status} name="status"/>,
        disableResizing: true,
        minWidth: 290,
        ...TableCellStatusBlock<IOrderIdSubscriber>(({ statusDescription, statusType, statusMessage }) => ({
            modalText: statusDescription,
            status: statusType,
            text: statusMessage,
        })),
    });

    return columnsConfig;
};
